/**
 * Copyright (c) 2021-22 Amway
 * @author Mohit Chunawala
 */

import React from "react";
import {
  addCartEntries,
  getCartEntries,
} from "../../../services/commerceServices/cartServices";
import ProductComponent from "../../summary/product";
import ReactHtmlParser from "react-html-parser";
import ProductCard from "../../shared-ui/product-card";
import { getLanguage } from "../../../services/commerceServices/accessToken";
import { utag, withUtag } from "../../analytics/analytics";
import {
  getUtagAuthObject,
  getUtagNeedStates,
  getUtagSessionObject,
} from "../../../utils/utagSession";
import _ from "lodash";

// Interface for ProductDetails Props
interface ProductDetailsProps {
  handleDetailsCart: (productCode: number, quantity: number) => void;
  hitStateData: any;
  handleDetailsOutofStock?: () => void;
  hitStateSubType?: string;
  t?: any;
}

// Interface for ProductDetails State
interface ProductDetailsState {
  option: string;
  hitStateData: any;
}

/**
 * ProductDetails component.
 *
 * @namespace ProductDetails
 */
class ProductDetails extends React.Component<
  ProductDetailsProps,
  ProductDetailsState
> {
  constructor(props: ProductDetailsProps) {
    super(props);
    this.state = {
      option: "",
      hitStateData: [],
    };
  }

  componentDidUpdate = () => {
    if (this.props.hitStateData !== this.state.hitStateData) {
      let hashValues = _.split(window.location.hash, "/#");

      window.history.replaceState(
        null,
        "",

        `${window.location.pathname}${hashValues[0]}`
      );

      let updatedHashValues = _.split(window.location.hash, "/#");
      window.history.replaceState(
        null,
        "",

        updatedHashValues.length === 1
          ? `${window.location.href}/#${this.props?.hitStateData[0]?.data?.code}`
          : `${window.location.pathname}${updatedHashValues[0]}/#${
              updatedHashValues[updatedHashValues.length - 1]
            }`
      );
      this.setState(
        {
          hitStateData: this.props.hitStateData,
          option: "description",
        },
        () => {
          let authObj = getUtagAuthObject();
          let sessionObj = getUtagSessionObject();
          let needStatesObj = getUtagNeedStates();
          let obj = {
            page_name: window.location.pathname.includes("summary")
              ? "My Products"
              : "My Results",
            event_name: "wellness_details",
            product_brand: [this.state?.hitStateData[0]?.data?.brandName],
            ...(this.state?.hitStateData[0]?.data?.price?.amwayValue
              ?.businessVolume && {
              product_businessVolume: [
                this.state?.hitStateData[0]?.data?.price?.amwayValue
                  ?.businessVolume,
              ],
            }),
            product_id: this.state?.hitStateData[0]?.data?.code,
            product_name: [this.state?.hitStateData[0]?.data?.name],
            ...(this.state?.hitStateData[0]?.data?.price?.amwayValue
              ?.pointValue && {
              product_pointValue: [
                this.state?.hitStateData[0]?.data?.price?.amwayValue
                  ?.pointValue,
              ],
            }),
            product_unitPrice: [
              this.state?.hitStateData[0]?.data?.price?.value,
            ],
            ...(window.location.pathname.includes("summary") && {
              wellness_filter: this.props?.hitStateSubType + "-products",
            }),
          };
          let updatedObj = _.merge(
            localStorage.getItem("user-info") ? authObj : {},
            localStorage.getObj("reco-result") ? needStatesObj : {},
            sessionObj,
            obj
          );
          //update to analytics
          withUtag().then((utag) => utag.view(updatedObj));
        }
      );
    }
  };
  handleOnChange = (data: any, e?: any) => {
    this.setState({ option: data });
  };
  handleOnChangeOnKeyPress = (e: any, data: any) => {
    if (e.key === "Enter") {
      this.handleOnChange(data);
    }
  };
  handleAddtoCart = (productCode: number, quantity: number) => {
    this.props.handleDetailsCart(productCode, quantity);
  };

  handleOutOfStock = () => {
    this.props.handleDetailsOutofStock && this.props.handleDetailsOutofStock();
  };

  render() {
    const { option } = this.state;

    return (
      <div className="product-details-wrapper">
        <div className="product-summary-wrapper bootstrap-wrapper">
          <div className="inner-wrapper col-md-12 clearfix">
            <div className="product-cards-wrapper pull-left col-md-12 col-lg-6">
              <ProductComponent
                {...this.props}
                productsData={this.props?.hitStateData}
                hitState={true}
                handleAddtoCart={(productCode: number, quantity) =>
                  this.handleAddtoCart(productCode, quantity)
                }
                handleOutOfStock={() => this.handleOutOfStock()}
              />
              {/* <ProductCard
                // productSliderSettings={settings}
                data={this.props.hitStateData}
                // handleLearnMore={() =>
                //   this.props.handleLearnMore &&
                //   this.props.handleLearnMore(index)
                // }
              /> */}
            </div>
          </div>
        </div>
        {/* Product details Start */}
        <div className="product-description-wrapper">
          <div className="description-options">
            {this.props.hitStateData &&
              this.props.hitStateData.length > 0 &&
              this.props?.hitStateData[0]?.data?.description && (
                <div
                  tabIndex={0}
                  role="button"
                  className={
                    option === "description" ? "option active" : "option"
                  }
                  onClick={() => this.handleOnChange("description")}
                  onKeyPress={(e: any) => {
                    if (e.key === "Enter" || e.key === " ") {
                      this.handleOnChange("description", e);
                    }
                  }}
                >
                  {this.props.t("common.product_details")}
                </div>
              )}
            {this.props.hitStateData &&
              this.props.hitStateData.length > 0 &&
              this.props?.hitStateData[0]?.data?.ingredients && (
                <div
                  tabIndex={0}
                  role="button"
                  className={
                    option === "ingredients" ? "option active" : "option"
                  }
                  onClick={() => this.handleOnChange("ingredients")}
                  onKeyPress={(e: any) => {
                    if (e.key === "Enter" || e.key === " ") {
                      this.handleOnChange("ingredients", e);
                    }
                  }}
                >
                  {this.props.t("common.ingredients")}
                </div>
              )}
            {this.props.hitStateData &&
              this.props.hitStateData.length > 0 &&
              this.props?.hitStateData[0]?.data?.faqs && (
                <div
                  tabIndex={0}
                  role="button"
                  className={option === "faqs" ? "option active" : "option"}
                  onClick={() => this.handleOnChange("faqs")}
                  onKeyPress={(e: any) => {
                    if (e.key === "Enter" || e.key === " ") {
                      this.handleOnChange("faqs", e);
                    }
                  }}
                >
                  {this.props.t("common.faqs")}
                </div>
              )}
            {this.props.hitStateData &&
              this.props.hitStateData.length > 0 &&
              this.props?.hitStateData[0]?.data?.useInstructions && (
                <div
                  tabIndex={0}
                  role="button"
                  className={
                    option === "instructions" ? "option active" : "option"
                  }
                  onClick={() => this.handleOnChange("instructions")}
                  onKeyPress={(e: any) => {
                    if (e.key === "Enter" || e.key === " ") {
                      this.handleOnChange("instructions", e);
                    }
                  }}
                >
                  {this.props.t("common.instructions")}
                </div>
              )}
          </div>
          {this.props.hitStateData && this.props.hitStateData.length > 0 && (
            <div className="middle-area">
              {/* Product Details Start */}
              <div className="product-details">
                {option === "description" &&
                  ReactHtmlParser(
                    (this.props?.hitStateData[0]?.data?.description)
                      .replaceAll("<strong>", '<span style="font-weight:600;">')
                      .replaceAll("</strong>", "</span>")
                      .replaceAll("<ul>", '<ul style="list-style:disc;">')
                  )}
                {/* {option === "ingredients" &&
                  ReactHtmlParser(
                    (this.props?.hitStateData[0]?.data?.ingredients).replaceAll(
                      'a href="/p',
                      'a href="https://qa.amway.com/p'
                    )
                  )} */}

                {option === "ingredients" &&
                  ReactHtmlParser(
                    (this.props?.hitStateData[0]?.data?.ingredients)
                      .replaceAll(
                        'a href="',

                        `a href=
                        ${process.env.REACT_APP_PRODUCT_REDIRECTION_URL}`
                      )
                      .replace(/['"]+/g, "")
                      .replaceAll("<strong>", '<span style="font-weight:600;">')
                      .replaceAll("</strong>", "</span>")
                      .replaceAll("<ul>", '<ul style="list-style:disc;">')
                      .replace("language", getLanguage())
                      .replaceAll("<a", '<a target="_blank"')
                  )}
                {option === "faqs" &&
                  ReactHtmlParser(
                    (this.props?.hitStateData[0]?.data?.faqs)
                      .replaceAll("<strong>", '<span style="font-weight:600;">')
                      .replaceAll("</strong>", "</span>")
                      .replaceAll("<ul>", '<ul style="list-style:disc;">')
                  )}
                {option === "instructions" &&
                  ReactHtmlParser(
                    (this.props?.hitStateData[0]?.data?.useInstructions)
                      .replaceAll("<strong>", '<span style="font-weight:600;">')
                      .replaceAll("</strong>", "</span>")
                      .replaceAll("<ul>", '<ul style="list-style:disc;">')
                  )}
                {/* <div className="description">
                Feeling stressed? A couple of mango lemon-flavored gummies can
                help you chill – without artificial colors, flavors or
                sweeteners. Amino Acid L-Theanine and calming botanical lemon
                balm team up to ease you down.† Forget the occasional stress and
                feel the yes.
              </div>
              <div className="description-points">
                <ul>
                  <li className="point">Vegetarian</li>
                  <li className="point">Vegetarian</li>
                  <li className="point">Vegetarian</li>
                </ul>
              </div>
              <div className="advisories-wrapper">
                <div className="title">Advisories:</div>
                <ul>
                  <li className="advisory">
                    If you have a medical condition, long-term mood disorder or
                    chronic illness; are taking prescription drugs; or are
                    pregnant or nursing, please consult your healthcare
                    professional prior to use.
                  </li>
                  <li className="advisory">Store in a cool, dry place.</li>
                  <li className="advisory">KEEP OUT OF REACH OF CHILDREN.</li>
                </ul>
              </div> */}
              </div>
              {/* Product Details Ends */}
            </div>
          )}
        </div>

        {/* Product details Ends */}
      </div>
    );
  }
}

export default ProductDetails;
